const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Material calculator embedded in product descriptions. Shopify strips <script>
// from descriptions, so the handlers live here (this file loads on every page).
document.addEventListener('click', function (e) {
  var calc = e.target.closest('.material-calculator-embed .calc-button');
  if (calc) return runMaterialCalculator(calc.closest('.material-calculator-embed'));
  var add = e.target.closest('.material-calculator-embed .calc-add-btn');
  if (add) return addCalculatedToCart(add.closest('.material-calculator-embed'), add);
});

function runMaterialCalculator(box) {
  var len = parseFloat(box.querySelector('#length-ft').value);
  var wid = parseFloat(box.querySelector('#width-ft').value);
  var dep = parseFloat(box.querySelector('#depth-in').value);
  var out = box.querySelector('#calculator-result');
  var row = box.querySelector('.calc-add-row');
  if (row) row.remove();
  out.style.display = 'block';
  if (!(len > 0 && wid > 0 && dep > 0)) {
    out.textContent = 'Please enter length, width and depth.';
    return;
  }
  var yards = (len * wid * (dep / 12)) / 27;
  var order = Math.max(1, Math.ceil(yards));
  out.innerHTML = 'You need about ' + yards.toFixed(2) + ' cubic yards.' +
    '<div style="margin-top:6px;">We recommend ordering ' + order + ' cubic yard' + (order === 1 ? '' : 's') + '.</div>';

  row = document.createElement('div');
  row.className = 'calc-add-row';
  row.style.cssText = 'display:flex;gap:8px;align-items:center;margin-top:12px;';
  row.innerHTML =
    '<input type="number" class="calc-add-qty" min="1" step="1" value="' + order + '" aria-label="Quantity" ' +
    'style="width:70px;padding:10px;border:1px solid #ccc;border-radius:4px;box-sizing:border-box;">' +
    '<button type="button" class="calc-add-btn" ' +
    'style="flex:1;background:#0056b3;color:#fff;padding:10px 15px;border:none;border-radius:4px;cursor:pointer;font-size:1em;">' +
    'Add to Cart</button>';
  var msg = box.querySelector('.calc-add-msg');
  if (!msg) {
    msg = document.createElement('div');
    msg.className = 'calc-add-msg';
    msg.setAttribute('aria-live', 'polite');
    msg.style.cssText = 'margin-top:8px;font-size:0.95em;';
    out.insertAdjacentElement('afterend', msg);
  }
  msg.textContent = '';
  out.insertAdjacentElement('afterend', row);
}

function addCalculatedToCart(box, btn) {
  var qty = parseInt(box.querySelector('.calc-add-qty').value, 10);
  var msg = box.querySelector('.calc-add-msg');
  var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (!(qty > 0)) { msg.textContent = 'Enter a quantity of 1 or more.'; return; }
  if (!idInput || !idInput.value) { msg.textContent = 'Please choose an option above first.'; return; }
  btn.disabled = true;
  btn.textContent = 'Adding...';
  fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: Number(idInput.value), quantity: qty, sections: 'cart-icon-bubble', sections_url: window.location.pathname }),
  })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart.');
      var bubble = document.getElementById('cart-icon-bubble');
      var html = res.body.sections && res.body.sections['cart-icon-bubble'];
      if (bubble && html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (el) bubble.innerHTML = el.innerHTML;
      }
      msg.innerHTML = 'Added ' + qty + ' to your cart. <a href="/cart" style="font-weight:bold;">View cart</a>';
    })
    .catch(function (err) { msg.textContent = err.message; })
    .then(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; });
}
